// extracted by mini-css-extract-plugin
export default {"statement":"OQMLq3jzmO","heading":"nz44GVZapN","body":"S24p3d8ihm","link":"QZhuqbqhAu"};